import { render } from "./MultistepMain.vue?vue&type=template&id=d23206fc&scoped=true"
import script from "./MultistepMain.vue?vue&type=script&lang=js"
export * from "./MultistepMain.vue?vue&type=script&lang=js"

import "./MultistepMain.vue?vue&type=style&index=0&id=d23206fc&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d23206fc"]])

export default __exports__